import { useQuery } from "@tanstack/react-query";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Checkbox, Select } from "expano-components";
import { updateProduct } from "actions/products";
import { ReactComponent as InfoIcon } from "icons/info.svg";

import package_boxes from "utils/package_boxes";
import getBrandLabels from "utils/queries/getBrandLabels";

const CheckField = (props) => <Checkbox {...props} />;
const SelectField = (props) => <Select {...props} />;

const BrandingForm = ({
  data,
  change,
  need_branding_pack,
  need_custom_brand_label,
  handleSubmit,
  submitting,
  pristine,
  updateProduct,
  match: {
    params: { id },
  },
}) => {
  const { data: brandLabelOptions = [] } = useQuery(
    ["brand_labels", "select"],
    () => getBrandLabels(),
    { enabled: Boolean(need_custom_brand_label) },
  );

  const onSubmit = async (values) => {
    await updateProduct(id, {
      ...values,
      brand_label_id: values.need_custom_brand_label
        ? values.brand_label_id
        : null,
    });
  };
  const options = Object.values(package_boxes)
    .flat()
    .filter(({ id }) => id !== "none")
    .map(({ id, name, sizes }) => ({
      label: `${name} - ${sizes.width}x${sizes.height}x${sizes.depth}cm`,
      value: id,
    }));

  return (
    <div className="dashboard m-b-0">
      <form noValidate onSubmit={handleSubmit(onSubmit)}>
        <header className="dashboard__header dashboard__header--edit">
          <div className="icon__container">
            <InfoIcon />
          </div>
          <h2 className="dashboard__title heading">Branding</h2>
        </header>
        <div className="dashboard__form p-t-10">
          <Field
            label="Produkt wymaga oklejenia etykietą sprzedażową 🏷️"
            name="need_branding_label"
            component={CheckField}
            disabled={!data.branding_label_url}
          />
          <Field
            label="Produkt wymaga oklejenia etykietą informacyjną ℹ️"
            name="need_instruction_label"
            component={CheckField}
            disabled={!data.name_en || !data.name_de}
          />
          <Field
            label="Produkt wymaga oklejenia etykietką markową 🎫"
            name="need_custom_brand_label"
            component={CheckField}
          />
          {need_custom_brand_label && (
            <div className="p-l-25" style={{ marginTop: "-10px" }}>
              <Field
                key={brandLabelOptions.map(({ value }) => value).join("-")}
                name="brand_label_id"
                label="Etykieta markowa"
                component={SelectField}
                options={brandLabelOptions}
                handleChange={(val) => change("brand_label_id", val)}
                defaultValue={brandLabelOptions.find(
                  ({ value }) => value === data.brand_label_id,
                )}
              />
            </div>
          )}
          <Field
            label="Produkt wymaga przepakowania 📦"
            name="need_branding_pack"
            component={CheckField}
          />
          {need_branding_pack && (
            <div className="p-l-25" style={{ marginTop: "-10px" }}>
              <Field
                name="branding_pack_box"
                component={SelectField}
                options={options}
                handleChange={(val) => change("branding_pack_box", val)}
                defaultValue={options.find(
                  ({ value }) => value === data.branding_pack_box
                )}
              />
            </div>
          )}
        </div>
        <div className="dashboard__form__footer">
          <Button
            disabled={pristine || submitting}
            type="save"
            text="Zapisz"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </form>
    </div>
  );
};

const selector = formValueSelector("alerts-form");

const mapStateToProps = ({ edit_product: { data }, ...state }) => ({
  initialValues: {
    need_branding_label: data.need_branding_label,
    need_custom_brand_label: data.need_custom_brand_label,
    need_instruction_label: data.need_instruction_label,
    need_branding_pack: data.need_branding_pack,
    branding_pack_box: data.branding_pack_box,
    brand_label_id: data.brand_label_id,
  },
  need_branding_pack: selector(state, "need_branding_pack"),
  need_custom_brand_label: selector(state, "need_custom_brand_label"),
  data,
});

const mapDispatchToProps = (dispatch) => ({
  updateProduct: (id, data) => dispatch(updateProduct(id, data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: "alerts-form",
    enableReinitialize: true,
  })(withRouter(BrandingForm)),
);
